import { useCallback } from 'react'
import { config } from '../../components/Init/Init'
import { showStore } from '../../sweepstakes/messages'
import { sweepsGeoStatusIsBlocked, verifyNotFrozen } from '../../services/utils'
import { useSetPlayerSmsInfo } from '../../services/store/playerStore/playerActions'
import { useStateValue } from '../../services/state/StateProvider'
import { usePlayerStore } from '../../services/store'
import { useCryptoPackageModal } from '../../components/CryptoPackageModal'

export const useOpenCoinStore = () => {
  const [_, dispatch] = useStateValue()

  const playerStore = usePlayerStore()
  const kycStatus = playerStore.use.kycStatus()
  const playerGeolocationStatus = playerStore.use.geolocationStatus()
  const playerSocialData = playerStore.use.socialData()
  const playerFreezeInfo = playerStore.use.playerFreezeInfo()

  const { setPlayerSmsInfo } = useSetPlayerSmsInfo()
  const { handleOpenCryptoPackageModal } = useCryptoPackageModal()

  const openCoinStore = useCallback(() => {
    // fail safe incase the geoblock modal is hidden by dom edit
    if (sweepsGeoStatusIsBlocked(playerGeolocationStatus, playerSocialData)) {
      return
    }

    if (verifyNotFrozen(playerFreezeInfo, config.freezeEvents.depositFrozen)) {
      const openDeposit = config.enableCryptoWallet ? handleOpenCryptoPackageModal : showStore

      setPlayerSmsInfo({
        smsVerifiedFunc: openDeposit
      })
    } else {
      const kycPopupReason =
        kycStatus === config.kycStatuses.Verified
          ? config.purchaseLimitKycStatus.PostKyc
          : config.purchaseLimitKycStatus.PreKyc

      dispatch({
        type: 'setModal',
        modals: {
          purchaseLimitKyc: { display: true, data: { reason: kycPopupReason } }
        }
      })
    }
  }, [dispatch, setPlayerSmsInfo, playerFreezeInfo, playerGeolocationStatus, playerSocialData])

  return { openCoinStore }
}
